<template>
  <div class="team">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>管理团队</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div
        class="box kf-animate kf-animate-top"
        :class="{
          'kf-animate-delay-200ms': index === 1,
          'kf-animate-delay-600ms': index === 2,
        }"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="sm_box"></div>
        <div
          class="box_img"
          :style="{ backgroundImage: 'url(' + item.image + ')' }"
        >
          <div class="__list_text" v-html="item.content"></div>
        </div>
        <p class="name">{{ item.title }}</p>
        <p class="title_name">{{ item.tips }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.getAjax();
    },
    getAjax() {
      this.getListAndInfo();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 280px;
  background: url(~@/assets/img/about/team.png) no-repeat center;
  background-size: cover;
}
.title_text {
  width: 360px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  text-align-last: justify;
  text-align: justify;
  line-height: 84px;
}
.g-box {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
  height: 824px;
  margin-bottom: 120px;
}
.sm_box {
  width: 60px;
  height: 60px;
  background: #ff8012;
}
.name {
  height: 40px;
  font-size: 28px;
  font-weight: 400;
  color: #000000;
  line-height: 40px;
  margin-top: 20px;
  margin-left: 30px;
}
.title_name {
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #656878;
  line-height: 22px;
  margin-top: 10px;
  margin-left: 30px;
}
.box {
  .box_img {
    width: 260px;
    height: 260px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin-top: -30px;
    margin-left: 30px;
    position: relative;
    overflow: hidden;
    .__list_text {
      position: absolute;
      left: 0;
      top: -100%;
      width: 100%;
      height: 100%;
      background: rgba(15, 40, 170, 0.8);
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      line-height: 24px;
      transition: top 0.3s;
    }
    &:hover {
      .__list_text {
        top: 0;
      }
    }
  }
}
</style>
